import { SVGProps } from 'react';
import { ReactComponent } from 'icons/plus.svg';

type Props = SVGProps<SVGSVGElement>;

/**
 * @deprecated Move to storybook instead
 */
export const PlusIcon = (props: Props) => {
  return <ReactComponent className="merc-icon-plus" {...props} />;
};
